declare const Image: any;
declare const window: any;

let pingSeq = 0;
/**
  * 发送一个http请求，一般用于数据上报
  * @param {string} url 请求url地址
*/
export function ping(url: string) {
  const img = new Image();
  img.id = `$__ping${pingSeq}`;
  pingSeq += 1;
  window[img.id] = img;

  img.onload = img.onerror = function () {
    window[img.id] = null;
    img.onload = img.onerror = null;
  };
  img.src = url;
}
